import { render } from "./MaterialProfile.vue?vue&type=template&id=8549fdb2"
import script from "./MaterialProfile.vue?vue&type=script&lang=js"
export * from "./MaterialProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__